import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UserLog } from '../user-log.model';

@JsonObject('UserLogsResultsResponse')
export class UserLogsResultsResponse extends ApiResultsResponse<UserLog> {

  @JsonProperty('results', [UserLog])
  override results: UserLog[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
